import { 
  collection,
  addDoc,
  updateDoc,
  doc,
  getDoc,
  getDocs,
  query,
  where,
  Timestamp
} from 'firebase/firestore';
import { db } from '../../../config/firebase';
import { DocumentTemplate } from '../../../types';

export const saveTemplate = async (template: Omit<DocumentTemplate, 'id'>): Promise<string> => {
  try {
    const docRef = await addDoc(collection(db, 'templates'), {
      ...template,
      createdAt: Timestamp.fromDate(new Date()),
      updatedAt: Timestamp.fromDate(new Date())
    });
    return docRef.id;
  } catch (error: any) {
    console.error('Error saving template:', error);
    throw new Error('Failed to save template');
  }
};

export const updateTemplate = async (id: string, template: Partial<DocumentTemplate>): Promise<void> => {
  try {
    await updateDoc(doc(db, 'templates', id), {
      ...template,
      updatedAt: Timestamp.fromDate(new Date())
    });
  } catch (error: any) {
    console.error('Error updating template:', error);
    throw new Error('Failed to update template');
  }
};

export const getTemplate = async (id: string): Promise<DocumentTemplate | null> => {
  try {
    const docRef = doc(db, 'templates', id);
    const docSnap = await getDoc(docRef);
    
    if (docSnap.exists()) {
      const data = docSnap.data();
      return {
        id: docSnap.id,
        ...data,
        createdAt: data.createdAt.toDate(),
        updatedAt: data.updatedAt.toDate()
      } as DocumentTemplate;
    }
    
    return null;
  } catch (error: any) {
    console.error('Error fetching template:', error);
    throw new Error('Failed to fetch template');
  }
};

export const getUserTemplate = async (userId: string): Promise<DocumentTemplate | null> => {
  try {
    const q = query(collection(db, 'templates'), where('userId', '==', userId));
    const querySnapshot = await getDocs(q);
    
    if (!querySnapshot.empty) {
      const doc = querySnapshot.docs[0];
      const data = doc.data();
      return {
        id: doc.id,
        ...data,
        createdAt: data.createdAt.toDate(),
        updatedAt: data.updatedAt.toDate()
      } as DocumentTemplate;
    }
    
    return null;
  } catch (error: any) {
    console.error('Error fetching user template:', error);
    throw new Error('Failed to fetch user template');
  }
};